// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".browser .browser-type-select{position:absolute;bottom:-70px;min-width:100%;background:#fff;z-index:505;display:flex;padding:0.5rem;box-shadow:0px 4px 13px rgba(71,86,109,0.29);border-radius:7px;gap:0.5rem}.browser .browser-type-select>div{background:#F0F3FB;font-size:1.2rem;font-weight:500;padding:1rem;cursor:pointer;transition:0.2s ease;border-radius:5px}.browser .browser-type-select>div:hover{background:#BBE9FF}\n", ""]);
// Exports
module.exports = exports;
